import React from 'react';

import { IUnpackedFeaturedProduct } from '../../../models/MessagePreview/UnpackedFeaturedProduct';
import { IUnpackedRelatedMovie } from '../../../models/MessagePreview/UnpackedRelatedMovie';
import FeaturedProductList from '../sharedUnpackeNewsComponents/FeaturedProductList';
import Footer from '../sharedUnpackeNewsComponents/Footer';
import LikeButton from '../sharedUnpackeNewsComponents/LikeButton';
import MainImage from '../sharedUnpackeNewsComponents/MainImage';
import MainText from '../sharedUnpackeNewsComponents/MainText';
import MoreLink from '../sharedUnpackeNewsComponents/MoreLink';
import RatingRepresentation from '../sharedUnpackeNewsComponents/RatingRepresentation';
import RelatedMovieList from '../sharedUnpackeNewsComponents/RelatedMovieList';
import Subject from '../sharedUnpackeNewsComponents/Subject';

interface IProps {
  subject: string;
  mainImage: string;
  mainText: string;
  more: string;
  featuredProducts: IUnpackedFeaturedProduct[];
  ranking: boolean;
  relatedMovies: IUnpackedRelatedMovie[];
  footerText: string;
  ratingIcons: string[];
  contentsDescriptors: string;
  interactiveElements: string;
  movieUrl: string;
}

const NewsBody = (props: IProps) => {
  const {
    subject,
    mainImage,
    movieUrl,
    mainText,
    featuredProducts,
    ranking,
    more,
    relatedMovies,
    footerText,
    ratingIcons,
    contentsDescriptors,
    interactiveElements,
  } = props;

  return(
    <div className="news-body">
      <Subject {...{ subject }} />
      <MainImage {...{ mainImage, movieUrl }} />
      <MainText mainText={mainText} tagSupported={true} />
      <FeaturedProductList {...{ featuredProducts, ranking }} />
      <MoreLink {...{ more }} />
      <RelatedMovieList {...{ relatedMovies }} />
      <LikeButton />
      <Footer {...{ footerText }} />
      <RatingRepresentation
        {...{ ratingIcons }}
        {...{ contentsDescriptors }}
        {...{ interactiveElements }}
      />
    </div>
  );
};

export default NewsBody;
